import { OrderProduct, Product } from "shared/api/middleware-api-client";
import { findStaander, isVerticalProfileExtra } from "./staander";
import { getStaanderPositionName } from "./layoutChoiceName";
import { VerticalBeamPosition } from "./layoutMeta";

export const getExtraOptionDisplayName = (
  code: string,
  name: string,
  staanderPosition: VerticalBeamPosition | undefined,
): string =>
  isVerticalProfileExtra(code) && staanderPosition
    ? `${name} — ${getStaanderPositionName(staanderPosition)}`
    : name;

export const getProductExtraOptionNames = (
  product: Product | OrderProduct,
): string[] => {
  if ("doorLayout" in product) return product.extraOptionsNames ?? [];

  const position = findStaander(
    product.measurements.widths,
    product.measurements.verticalBeams,
  );
  return (product.extraOptions ?? []).map((option) =>
    getExtraOptionDisplayName(option.code, option.name, position),
  );
};
